import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { MobileTopBar } from "@/components/MobileTopBar";
import { Toaster } from "@/components/ui/sonner";

export function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer on route change.
  useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);

  // Lock body scroll while the drawer is open.
  useEffect(() => {
    document.body.style.overflow = mobileNavOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileNavOpen]);

  return (
    <div className="App flex min-h-screen bg-[#F7F7F4]">
      {/* Desktop sidebar — always visible on md+ */}
      <div className="hidden md:flex md:shrink-0">
        <Sidebar />
      </div>

      {/* Mobile drawer + backdrop */}
      {mobileNavOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setMobileNavOpen(false)}
          data-testid="mobile-nav-backdrop"
        />
      )}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-72 md:hidden transform transition-transform duration-200 shadow-xl ${
          mobileNavOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        data-testid="mobile-nav-drawer"
      >
        <Sidebar onNavigate={() => setMobileNavOpen(false)} />
      </div>

      <main className="flex-1 min-w-0">
        <MobileTopBar onMenu={() => setMobileNavOpen(true)} />
        <div className="px-4 py-4 md:px-8 md:py-6 max-w-[1500px] mx-auto fade-in">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
}
